


















































import { Component } from "vue-property-decorator";
import { required, validDate, validHora } from "@/shared/validators";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import ImageCropper from "@/shared/components/image-cropper.vue";
import { Premio, PromocaoService } from "@/services/promocao.service";

import {
  IdTipoAtendimento,
  TipoAtendimento,
} from "@/services/consultores.service";

@Component({
  components: { ImageCropper },
})
export default class NovoPremio extends mixins(GlobalMixin) {
  premio: Premio | null = null;
  idPromocao!: number;
  idPremioPromocao: number | null = null;
  selectedFile: null | File = null;
  tipo: number | null = null;
  descricao: string | null = "";
  data: string | null = "";
  hora: string | null = "";
  cropper: null | Cropper = null;
  imagemUrl = "";
  url = "";
  file: null | string = null;
  imagem: string | null = "";

  tipoAtendimento: TipoAtendimento = {
    descricao: "",
    idTipoAtendimento: IdTipoAtendimento["SuporteSistema"],
  };

  rules = {
    descricao: [required()],
    data: [validDate()],
    hora: [validHora()],
  };

  get tituloManter(): string {
    return "Novo Prêmio";
  }

  mounted() {
    this.fetchPremio();
  }

  async fetchPremio() {
    this.idPromocao = Number(this.$route.params.idPromocao);
    this.idPremioPromocao = Number(this.$route.params.idPremioPromocao);
    this.url = await PromocaoService.ObterUrlImagemPremio();
    this.premio = await PromocaoService.PopPremio(
      this.idPromocao,
      this.idPremioPromocao
    );
    if (this.premio) {
      if (!this.idPremioPromocao) {
        this.premio.colocacao = Number(this.$route.params.colocacao) + 1;
      }
      this.imagemUrl = this.url + this.premio.imagem;
    }
  }

  async salvarPremio() {
    const form = this.$refs.form as any;
    if (form.validate()) {
      this.imagem = await PromocaoService.UploadImagemPremio(this.file!);
      if (this.premio) {
        this.startLoader();
        this.premio.imagem = this.imagem!;
        this.premio.idPromocao = this.idPromocao;
        await PromocaoService.SalvarPremio(this.premio).finally(
          this.stopLoader
        );
        this.voltar();
      }
    }
  }

  voltar() {
    this.$router.push({
      name: "alterarpromocao",
      params: { idPromocao: this.idPromocao + "" },
    });
  }
}
